/**
 * RPM Constants
 *
 * Centralized constants for RPM components to ensure consistency
 * and make configuration changes easier.
 */

/**
 * Polling interval configuration for process status updates
 */
export const POLLING_INTERVALS = {
  /** Polling interval for processes in active states (CreationInProgress, ExportInProgress) */
  ACTIVE_PROCESS: 30000, // 30 seconds

  /** Polling interval for processes in inactive states */
  INACTIVE_PROCESS: 60000, // 60 seconds

  /** Maximum number of retry attempts before stopping polling */
  MAX_RETRY_ATTEMPTS: 60,

  /** Total timeout for polling (30 minutes) */
  TIMEOUT: 30 * 60 * 1000,
} as const;

/**
 * Default configuration for RPM Claims Search
 */
export const CLAIMS = {
  /**
   * Default date range for claim creation date filter.
   * Set to 180 days (6 months) to balance between showing recent claims
   * and avoiding performance issues with large datasets.
   * Users can override this via the date range filter.
   */
  DEFAULT_DATE_RANGE_DAYS: 180,

  /** Available rows per page options in claims table */
  ROWS_PER_PAGE_OPTIONS: [10, 25, 50, 100],

  /** Default rows per page */
  DEFAULT_ROWS_PER_PAGE: 25,
} as const;

/**
 * Spinner sizes for loading indicators
 */
export const LOADING_SPINNER_SIZE = 20;

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  INVALID_STORAGE: 'Invalid user information in storage',
  CLINIC_FETCH_FAILED: 'Error fetching clinics',
  CLAIMS_FETCH_FAILED: 'Error fetching claims',
  PERMISSION_DENIED: 'You do not have permission to view claims. Please contact your administrator.',
  INVALID_RESPONSE: 'Received invalid data from server',
  EXPORT_FAILED: 'Cannot export the Notes',
  CSV_EXPORT_FAILED: 'Error exporting claims to CSV. Please try again or contact support.',
  NO_CLAIMS_SELECTED: 'No claims selected for export',
  NO_EXPORTABLE_CLAIMS: 'No exported claims selected. Only exported claims can be downloaded.',
} as const;

/**
 * Success messages
 */
export const SUCCESS_MESSAGES = {
  EXPORT_SUCCESS: 'Export was successful',
} as const;
